import { render, staticRenderFns } from "./procedure-template-create.vue?vue&type=template&id=47346965&scoped=true&"
import script from "./procedure-template-create.vue?vue&type=script&lang=js&"
export * from "./procedure-template-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47346965",
  null
  
)

export default component.exports